import { useCallback, useState } from 'react'
import { useOverwrite } from './Inputs.utils'

/**
 * The CheckBox's custom hook.
 */
const useCheckBox = ({
  changeCallback = () => undefined,
  initialValue = false,
  overwriteCallback = () => undefined
} = {}) => {
  const [value, setValue] = useState(initialValue)
  const handleChange = useCallback(
    event => {
      setValue(event?.target?.checked)
      changeCallback(event?.target?.checked, event?.target?.name)
    },
    [changeCallback]
  )
  const handleReset = useCallback(() => setValue(initialValue), [initialValue])

  useOverwrite(value, overwriteCallback, updatedValue => setValue(updatedValue))

  return { value, setValue, onChange: handleChange, onReset: handleReset }
}

export default useCheckBox
